module.exports = __webpack_public_path__ + "img/des_kalinba_4.7440602c.jpg";